import { maximumMapBounds } from '../domain/camera.ts';
import { parseCameraHash } from '../domain/camera-hash.ts';
import { createTrailId, type TrailId } from '../domain/trails.ts';

export interface TrailSelectionUrlState {
  readonly hasExplicitCamera: boolean;
  readonly initialTrailId: TrailId | null;
  replace(trailId: TrailId | null): void;
}

export function parseTrailIdQuery(search: string): TrailId | null {
  const values = new URLSearchParams(search).getAll('trailid');
  const value = values[0];
  if (values.length !== 1 || value === undefined || !/^[1-9][0-9]*$/u.test(value)) return null;
  return createTrailId(value);
}

export function createBrowserTrailSelectionUrlState(
  browserWindow: Pick<Window, 'history' | 'innerHeight' | 'location'>,
): TrailSelectionUrlState {
  return Object.freeze({
    initialTrailId: parseTrailIdQuery(browserWindow.location.search),
    hasExplicitCamera:
      parseCameraHash(browserWindow.location.hash, {
        bounds: maximumMapBounds,
        viewportHeight: browserWindow.innerHeight,
      }) !== undefined,
    replace(trailId: TrailId | null): void {
      const parameters = new URLSearchParams(browserWindow.location.search);
      if (trailId === null) parameters.delete('trailid');
      else parameters.set('trailid', trailId);
      const query = parameters.toString();
      browserWindow.history.replaceState(
        null,
        '',
        `${browserWindow.location.pathname}${query === '' ? '' : `?${query}`}${browserWindow.location.hash}`,
      );
    },
  });
}
